module.exports = __webpack_public_path__ + "static/media/3.02c7cce1.jpg";